import VueCookies from 'vue-cookies'
import VueSanitize from "vue-sanitize"
import FaqBlock from '@nek-embedded-faq/components/FaqBlock'

Vue.use(VueCookies)
Vue.use(VueSanitize)

const faqBlockWrapper = document.querySelector('.block-section.faq .nek-embedded-faq-wrapper');
if (faqBlockWrapper) {
	const faqBlockId = faqBlockWrapper.id;
	const faqData = window.nekfaqconfig;
	new Vue({
		render: h => h(FaqBlock, { 
			props: faqData
		}),
	}).$mount('#' + faqBlockId);
}
const faqQuestionForm = document.getElementById('faq-question-form');
const faqClose = document.getElementById('faq-question-form-close');
const faqOpenButtons = document.querySelectorAll('.faq-question-form-open');
if (faqClose) {
	faqClose.addEventListener('click', function() {
		faqQuestionForm.classList.remove('active');
		faqClose.ariaExpanded = false;
        document.body.classList.remove('overlay-active');
	})
}
if (faqOpenButtons && faqOpenButtons.length>0) {
	for (let i = 0; i<faqOpenButtons.length; i++) {
		faqOpenButtons[i].ariaControls = 'faq-question-form';
		faqOpenButtons[i].addEventListener('click', function(e) {
            document.body.classList.add('overlay-active');
			e.target.ariaExpanded = true;
			faqQuestionForm.classList.add('active');
		})
	}
}

/**
 * Logic to handle showing/hiding/updating the subcategories select when the standard is changed in the form.
 */

const faqTypeSelect = document.getElementById('faqType');
const faqSubtypeWrapper = document.getElementById('faq-sub-cat');
if (faqSubtypeWrapper) {
    const faqSubtypeSelect = document.getElementById('faqSubType');
    faqTypeSelect.addEventListener('change', (e) => {
        const type = e.target.value;
        if (type == '' || type == 'Velg' || type == '0') {
            faqSubtypeWrapper.style.display = 'none';
        }
        
        // clear the subcategory select in case it was previously populated
        while (faqSubtypeSelect.options.length > 1) {
            faqSubtypeSelect.remove(1);
        }
        
        nek_get_subcategories(type, nek_update_subcategories);
    });

    faqSubtypeWrapper.classList.add('hidden');
    faqSubtypeWrapper.ariaHidden = true;

    function nek_update_subcategories(response) {
        const response_object = JSON.parse(response);
        const subcategories = response_object.data.subcategories;
        if (subcategories.length===0) {
            faqSubtypeWrapper.classList.add('hidden');
            faqSubtypeWrapper.ariaHidden = true;
        } else {
            faqSubtypeWrapper.classList.remove('hidden');
            faqSubtypeWrapper.ariaHidden = false;
        }
        
        if (subcategories.length>0) {
            subcategories.forEach((item, index) => {
                let option = document.createElement("option");
                option.text = item.name;
                option.value = item.name;
                faqSubtypeSelect.add(option);
            })
        }
    }

    function nek_get_subcategories(type, nek_subcategories_callback) {
        const theUrl = window.nekfaqconfig.settings.subcategories_endpoint + type.replace(' ', '-').toLowerCase()
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = function() { 
            if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
                nek_subcategories_callback(xmlHttp.responseText);
        }
        xmlHttp.open("GET", theUrl, true); // true for asynchronous 
        xmlHttp.send(null);
    }
}
